var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid mb-1" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-center gap-2 bg-gray2 py-1 mx-md-1",
        },
        [
          _c("span", { staticClass: "h4" }, [_vm._v("Fibre ou ADSL ?")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: { href: _vm.eligibilityUrl },
            },
            [
              _c("span", { staticClass: "d-none d-md-inline" }, [
                _vm._v("Tester votre éligibilité"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "d-md-none" }, [_vm._v("Tester")]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }